import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-five',
  templateUrl: './c1-one-one-one-five.component.html',
  styleUrls: ['./c1-one-one-one-five.component.scss']
})
export class C1OneOneOneFiveComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.5_Teaching methodology.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
